/* eslint quote-props: ["error", "consistent"] */

const locale = {};

export default locale;
